import { render, staticRenderFns } from "./SkillChipSelect.vue?vue&type=template&id=2c8ec84b&scoped=true"
import script from "./SkillChipSelect.vue?vue&type=script&lang=js"
export * from "./SkillChipSelect.vue?vue&type=script&lang=js"
import style0 from "./SkillChipSelect.vue?vue&type=style&index=0&id=2c8ec84b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ec84b",
  null
  
)

export default component.exports